var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vk-button',{attrs:{"type":_vm.type,"html-type":_vm.htmlType,"disabled":_vm.disabled || _vm.loading}},[(_vm.loading)?[_c('vk-spinner',{attrs:{"ratio":"0.6"}})]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }